import { render, staticRenderFns } from "./UserResetPasswordInputHandler.vue?vue&type=template&id=54964840"
import script from "./UserResetPasswordInputHandler.vue?vue&type=script&lang=js"
export * from "./UserResetPasswordInputHandler.vue?vue&type=script&lang=js"
import style0 from "./UserResetPasswordInputHandler.vue?vue&type=style&index=0&id=54964840&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports